import React, { Component } from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '../../components/Button';
import { showNoticeTemplateModal } from '../../actions/Modal';

class AddNewTemplateButton extends Component {
  static propTypes = {
    showNoticeTemplateModal: func,
  };

  static defaultProps = {
    showNoticeTemplateModal: () => {},
  };

  shouldComponentUpdate() {
    return false;
  }

  handleButtonClick = () => this.props.showNoticeTemplateModal();

  render() {
    return (
      <Box
        sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'center', p: 2 }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleButtonClick}
          iconLeft={<AddIcon />}
          fullWidth
          labelId="buttons.text.addNewTemplate"
          className="lowercase"
          sx={{ maxWidth: 360 }}
        />
      </Box>
    );
  }
}

export default connect(
  null,
  { showNoticeTemplateModal },
)(AddNewTemplateButton);
